import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Esito } from '../../../models/esito';

@Component({
    selector: '[add_doc_to_esito]',
  templateUrl: 'add-to-esito.component.html',
})

export class AddDocumentoToEsitoComponent {
  @Input()
  esito: Esito;

  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(esito: Esito) {
    this.onClickAddToEntity.emit(esito);
  }
}
